import CONSTANTS from './constants';

export const loadOutput = () => ({
    type: CONSTANTS.LOAD_OUTPUT
});
